import { UserManager } from "./../../Services/UserManager/user-manager";
import { LessonCard } from "./../../Models/lessons.interface";
import { LessonManagerService } from "./../../Services/LessonManager/lesson-manager.service";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { GlobalVariablesService } from "../../Services/globalVariables/global-variables.service";
import { ScrollService } from "../../Services/ScrollManager/scroll.service";
import { LanguageConfig as config } from "src/app/locale/config";
import { LanguageSwitchService } from "../../Services/LanguageSwitch/language-switch.service";

@Component({
  selector: "app-lessons-flat",
  templateUrl: "./lessons-flat.component.html",
  styleUrls: [
    "./lessons-flat.component.css",
    /*'./lessonPhotos.css',*/ "../../app.component.css",
  ],
  providers: [LessonManagerService],
})
export class LessonsFlatComponent implements OnInit {
  count = 1;
  config;
  lessonCards: Array<LessonCard>;
  lessonIDs = Array<string>();
  // lessonsList$: FirebaseListObservable<LessonCard[]>;

  constructor(
    private lsnManager: LessonManagerService,
    private router: Router,
    public um: UserManager,
    private gv: GlobalVariablesService,
    private scroll: ScrollService,
    private ls: LanguageSwitchService
  ) {
    this.ls.config.subscribe({
      next: (config) => {
        this.config = config;
      },
    });
    this.lessonCards = this.lsnManager.getLessonCards();
    this.lessonIDs = [];
    for (let lesson of this.lessonCards) {
      this.lessonIDs.push(`flatLesson${lesson.id}`);
      // console.log(lesson.id)
    }
  }

  ngAfterViewChecked() {}

  ngOnInit() {}

  showLoginScreen() {
    this.um.openLogin();
  }
  scrollRight() {
    if (this.count <= 20) {
      this.count += 5;
      this.scroll.scrollHorizontalInContainer(
        "#flatLessonContainer",
        `#flatLesson${this.count}`
      );
    }
    //  console.log(this.count)
  }
  scrollLeft() {
    // console.log(this.count)
    if (this.count >= 4) {
      this.count -= 5;
      this.scroll.scrollHorizontalInContainer(
        "#flatLessonContainer",
        `#flatLesson${this.count}`
      );
    } else {
      this.scroll.scrollHorizontalInContainer(
        "#flatLessonContainer",
        `#flatLesson1`
      );
    }
  }

  async chooseLesson(lessonCard: LessonCard) {
    if (lessonCard.id > 2) {
      // make sure user profile is not annonymous.  If so, they need to sign up, if not, they need to login.
      let loggedIn = await this.um.isLoggedIn();
      if (loggedIn) {
        this.um.gotoLessonHeader(lessonCard.id);
        // this.router.navigate(['/lesson-header', {id: lessonCard.id, title: lessonCard.title, img: lessonCard.img}]);
        return;
      } else {
        // display message telling user to login.
        this.showLoginScreen();
        return;
      }
    } else {
      this.um.gotoLessonHeader(lessonCard.id);
      // this.router.navigate(['/lesson-header', {id: lessonCard.id, title: lessonCard.title, img: lessonCard.img}]);
    }
  }
}
